// src/utilities/courierList.js
const curierList = [
  { id: '32', code: 'Gati', courier: 'GATI', cId: 1, for: 'gati' },
  { id: '32', code: 'Gati', courier: 'GATI', cId: 2, for: 'gati-manual' },
  { id: '1', code: 'Fedex', courier: 'FEDEX', cId: 3, for: 'fedex' },
  { id: '1', code: 'Fedex', courier: 'FEDEX', cId: 4, for: 'fedex-manual' },
  {
    id: '4',
    code: 'Delhivery',
    courier: 'DELHIVERY',
    cId: 5,
    for: 'delhiveryb2c',
  },
  {
    id: '4',
    code: 'Delhivery mini-Gs',
    courier: 'DELHIVERY',
    cId: 6,
    for: 'delhiveryb2c-500g-manual',
  },
  {
    id: '4',
    code: 'Delhivery heavy-Gs',
    courier: 'DELHIVERY',
    cId: 7,
    for: 'delhiveryb2c-heavy-manual',
  },
  {
    id: '4',
    code: 'Delhivery light-Gs',
    courier: 'DELHIVERY',
    cId: 8,
    for: 'delhiveryb2c-light-manual',
  },
  {
    id: '4',
    code: 'Delhivery-Gs',
    courier: 'DELHIVERY',
    cId: 9,
    for: 'delhiveryb2b-manual',
  },
  {
    id: '4',
    code: 'Delhivery mini',
    courier: 'DELHIVERY',
    cId: 10,
    for: 'delhiveryb2c-500g',
  },
  {
    id: '4',
    code: 'Delhivery heavy',
    courier: 'DELHIVERY',
    cId: 11,
    for: 'delhiveryb2c-heavy',
  },
  {
    id: '4',
    code: 'Delhivery light',
    courier: 'DELHIVERY',
    cId: 12,
    for: 'delhiveryb2c-light',
  },
  {
    id: '4',
    code: 'Delhivery',
    courier: 'DELHIVERY',
    cId: 13,
    for: 'delhiveryb2b',
  },

  {
    id: '4',
    code: 'Delhivery Mini-Gs',
    courier: 'DELHIVERY',
    cId: 20,
    for: 'delhiveryb2c-500g',
  },
  {
    id: '4',
    code: 'Delhivery Heavy-Gs',
    courier: 'DELHIVERY',
    cId: 21,
    for: 'delhiveryb2c-heavy',
  },
  {
    id: '4',
    code: 'Delhivery Light-Gs',
    courier: 'DELHIVERY',
    cId: 22,
    for: 'delhiveryb2c-light',
  },

  {
    id: '26',
    code: 'SafeExpress',
    courier: 'SAFE EXPRESS',
    cId: 14,
    for: 'safeExpress',
  },
  {
    id: '3',
    code: 'EcomExpress',
    courier: 'ECOM EXPRESS',
    cId: 15,
    for: 'ecomExpress',
  },
  {
    id: '3',
    code: 'Ecom mini',
    courier: 'ECOM EXPRESS',
    cId: 16,
    for: 'ecomExpress-mini',
  },
  {
    id: '3',
    code: 'EcomExpress-Gs',
    courier: 'ECOM EXPRESS',
    cId: 17,
    for: 'ecomExpress-manual',
  },

  {
    id: '3',
    code: 'ECom (EGS)-Gs',
    courier: 'ECOM EXPRESS',
    cId: 23,
    for: 'ecomExpress',
  },
  {
    id: '3',
    code: 'ECom (EXS)-Gs',
    courier: 'ECOM EXPRESS',
    cId: 24,
    for: 'ecomExpress-mini',
  },

  { id: '36', code: 'TCI', courier: 'TCI EXPRESS', cId: 18, for: 'tciExpress' },
  {
    id: '36',
    code: 'TCI-Gs',
    courier: 'TCI EXPRESS',
    cId: 18,
    for: 'tciExpress-manual',
  },
  {
    id: '36',
    code: 'TCI-Gs',
    courier: 'TCI EXPRESS',
    cId: 18,
    for: 'tciExpress',
  },
  {
    id: '6',
    code: 'XpressBees',
    courier: 'XPRESSBEES',
    cId: 19,
    for: 'xpressBees',
  },
  {
    id: '6',
    code: 'XpressBees-Gs',
    courier: 'XPRESSBEES',
    cId: 19,
    for: 'xpressBees-manual',
  },
  {
    id: '6',
    code: 'Xpressbees - Gs',
    courier: 'XPRESSBEES',
    cId: 25,
    for: 'xpressBees',
  },
  {
    id: '6',
    code: 'Xpressbees-heavy - Gs',
    courier: 'XPRESSBEES',
    cId: 29,
    for: 'xpressBees-heavy',
  },

  {
    id: '5',
    code: 'Bluedart-Gs',
    courier: 'BLUEDART',
    cId: 26,
    for: 'bluedart',
  },
  { id: '8', code: 'DTDC-Gs', courier: 'DTDC', cId: 27, for: 'dtdc' },
  { id: '8', code: 'DTDC-Gs', courier: 'DTDC', cId: 28, for: 'dtdc-manual' },

  {
    id: '404',
    code: 'Rocket-Box-Gs',
    courier: 'ROCKET BOX',
    cId: 30,
    for: 'rocketbox',
  },
  {
    id: '404',
    code: 'Rocket-Box-Gs',
    courier: 'ROCKETBOX-MANUAL',
    cId: 31,
    for: 'rocketbox-manual',
  },
  {
    id: '105',
    code: 'SHIPROCKET-Gs',
    courier: 'SHIPROCKET',
    cId: 32,
    for: 'shiprocket',
  },
  {
    id: '36',
    code: 'TCI-Gs',
    courier: 'TCIEXPRESSDACC',
    cId: 18,
    for: 'tciExpressDACC',
  },
  {
    id: '170',
    code: 'ITHINK-Gs',
    courier: 'ITHINKLOGISTICS',
    cId: 33,
    for: 'ithinklogistics',
  },
  {
    id: '519',
    code: 'SHIPYAARI-Gs',
    courier: 'SHIPYAARI MANUAL',
    cId: 34,
    for: 'shipyaari-manual',
  },
  {
    id: '519',
    code: 'SHIPYAARI-Gs',
    courier: 'SHIPYAARI',
    cId: 35,
    for: 'shipyaari',
  },
  {
    id: '6',
    code: 'Xpressbees-heavy - Gs',
    courier: 'XPRESSBEES',
    cId: 36,
    for: 'xpressBees-ultra-heavy',
  },
];

export const courierList = [
  // GATI
  { label: 'Gati', value: 'gati', id: '32', code: 'Gati', cId: 1 },
  { label: 'Gati (Manual)', value: 'gati-manual', id: '32', code: 'Gati', cId: 2 },

  // FEDEX
  { label: 'FedEx', value: 'fedex', id: '1', code: 'Fedex', cId: 3 },
  { label: 'FedEx (Manual)', value: 'fedex-manual', id: '1', code: 'Fedex', cId: 4 },

  // DELHIVERY
  { label: 'Delhivery B2C', value: 'delhiveryb2c', id: '4', code: 'Delhivery', cId: 5 },
  { label: 'Delhivery B2B', value: 'delhiveryb2b', id: '4', code: 'Delhivery', cId: 13 },
  { label: 'Delhivery Mini (500g)', value: 'delhiveryb2c-500g', id: '4', code: 'Delhivery mini', cId: 10 },
  { label: 'Delhivery Heavy', value: 'delhiveryb2c-heavy', id: '4', code: 'Delhivery heavy', cId: 11 },
  { label: 'Delhivery Light', value: 'delhiveryb2c-light', id: '4', code: 'Delhivery light', cId: 12 },
  { label: 'Delhivery B2B (Manual)', value: 'delhiveryb2b-manual', id: '4', code: 'Delhivery-Gs', cId: 9 },
  { label: 'Delhivery Mini 500g (Manual)', value: 'delhiveryb2c-500g-manual', id: '4', code: 'Delhivery mini-Gs', cId: 6 },
  { label: 'Delhivery Heavy (Manual)', value: 'delhiveryb2c-heavy-manual', id: '4', code: 'Delhivery heavy-Gs', cId: 7 },
  { label: 'Delhivery Light (Manual)', value: 'delhiveryb2c-light-manual', id: '4', code: 'Delhivery light-Gs', cId: 8 },

  // SAFE EXPRESS
  { label: 'Safe Express', value: 'safeExpress', id: '26', code: 'SafeExpress', cId: 14 },

  // ECOM EXPRESS
  { label: 'Ecom Express', value: 'ecomExpress', id: '3', code: 'EcomExpress', cId: 15 },
  { label: 'Ecom Express Mini', value: 'ecomExpress-mini', id: '3', code: 'Ecom mini', cId: 16 },
  { label: 'Ecom Express (Manual)', value: 'ecomExpress-manual', id: '3', code: 'EcomExpress-Gs', cId: 17 },

  // TCI EXPRESS
  { label: 'TCI Express', value: 'tciExpress', id: '36', code: 'TCI', cId: 18 },
  { label: 'TCI Express (Manual)', value: 'tciExpress-manual', id: '36', code: 'TCI-Gs', cId: 18 },
  { label: 'TCI Express DACC', value: 'tciExpressDACC', id: '36', code: 'TCI-Gs', cId: 18 },

  // XPRESSBEES
  { label: 'XpressBees', value: 'xpressBees', id: '6', code: 'XpressBees', cId: 19 },
  { label: 'XpressBees Heavy', value: 'xpressBees-heavy', id: '6', code: 'Xpressbees-heavy - Gs', cId: 29 },
  { label: 'XpressBees Ultra Heavy', value: 'xpressBees-ultra-heavy', id: '6', code: 'Xpressbees-heavy - Gs', cId: 36 },
  { label: 'XpressBees (Manual)', value: 'xpressBees-manual', id: '6', code: 'XpressBees-Gs', cId: 19 },

  // BLUEDART
  { label: 'BlueDart', value: 'bluedart', id: '5', code: 'Bluedart-Gs', cId: 26 },

  // DTDC
  { label: 'DTDC', value: 'dtdc', id: '8', code: 'DTDC-Gs', cId: 27 },
  { label: 'DTDC (Manual)', value: 'dtdc-manual', id: '8', code: 'DTDC-Gs', cId: 28 },

  // ROCKET BOX
  { label: 'Rocket Box', value: 'rocketbox', id: '404', code: 'Rocket-Box-Gs', cId: 30 },
  { label: 'Rocket Box (Manual)', value: 'rocketbox-manual', id: '404', code: 'Rocket-Box-Gs', cId: 31 },

  // SHIPROCKET
  { label: 'Shiprocket', value: 'shiprocket', id: '105', code: 'SHIPROCKET-Gs', cId: 32 },

  // ITHINK LOGISTICS
  { label: 'iThink Logistics', value: 'ithinklogistics', id: '170', code: 'ITHINK-Gs', cId: 33 },

  // SHIPYAARI
  { label: 'Shipyaari', value: 'shipyaari', id: '519', code: 'SHIPYAARI-Gs', cId: 35 },
  { label: 'Shipyaari (Manual)', value: 'shipyaari-manual', id: '519', code: 'SHIPYAARI-Gs', cId: 34 },
];

// courierList.js - Frontend Courier List
// The 'value' field MUST match the 'for' field in curierListAPIside (backend)
// Because getCourier() function matches by 'for' field

export const courierListOrder = [
  // DELHIVERY
  {
    label: 'Delhivery (B2C-500g)',
    value: 'delhiveryb2c-500g',      // matches curierListAPIside.for
    cId: 10,
    genDocket: true,
  },
  {
    label: 'Delhivery (B2C-Light)',
    value: 'delhiveryb2c-light',     // matches curierListAPIside.for
    cId: 12,
    genDocket: true,
  },
  {
    label: 'Delhivery (B2C-Heavy)',
    value: 'delhiveryb2c-heavy',     // matches curierListAPIside.for
    cId: 11,
    genDocket: true,
  },

  // XPRESSBEES
  {
    label: 'XpressBees Light',
    value: 'xpressBees',             // matches curierListAPIside.for
    cId: 19,
    genDocket: true,
  },
  {
    label: 'XpressBees Heavy',
    value: 'xpressBees-heavy',       // matches curierListAPIside.for
    cId: 29,
    genDocket: true,
  },
  {
    label: 'XpressBees Ultra Heavy',
    value: 'xpressBees-ultra-heavy', // matches curierListAPIside.for
    cId: 36,
    genDocket: true,
  },

  // ECOM EXPRESS
  {
    label: 'Ecom Express',
    value: 'ecomExpress',            // matches curierListAPIside.for
    cId: 15,
    genDocket: true,
  },
  {
    label: 'Ecom Express Mini',
    value: 'ecomExpress-mini',       // matches curierListAPIside.for
    cId: 16,
    genDocket: true,
  },

  // BLUEDART
  {
    label: 'BlueDart',
    value: 'bluedart',               // matches curierListAPIside.for
    cId: 26,
    genDocket: true,
  },

  // DTDC
  {
    label: 'DTDC',
    value: 'dtdc',                   // matches curierListAPIside.for
    cId: 27,
    genDocket: true,
  },

  // TCI EXPRESS
  {
    label: 'TCI Express',
    value: 'tciExpress',             // matches curierListAPIside.for
    cId: 18,
    genDocket: true,
  },
  {
    label: 'TCI Express (DADC)',
    value: 'tciExpressDACC',         // matches curierListAPIside.for
    cId: 18,
    genDocket: true,
  },

  // ROCKET BOX
  {
    label: 'Rocket Box',
    value: 'rocketbox',              // matches curierListAPIside.for
    cId: 30,
    genDocket: true,
  },

  // SHIPROCKET
  {
    label: 'ShipRocket',
    value: 'shiprocket',             // matches curierListAPIside.for
    cId: 32,
    genDocket: true,
  },

  // ITHINK LOGISTICS
  {
    label: 'iThink Logistics',
    value: 'ithinklogistics',        // matches curierListAPIside.for
    cId: 33,
    genDocket: true,
  },

  // SHIPYAARI
  {
    label: 'ShipYaari',
    value: 'shipyaari',              // matches curierListAPIside.for
    cId: 35,
    genDocket: false,
  },
  {
    label: 'ShipYaari Manual',
    value: 'shipyaari-manual',       // matches curierListAPIside.for
    cId: 34,
    genDocket: false,
  },
];



// Helper function to get courier by value
export const getCourierByValue = (value) => {
  return courierList.find(courier => courier.value === value);
};

// Helper function to get only carriers that can generate dockets
export const getDocketGeneratingCouriers = () => {
  return courierList.filter(courier => courier.genDocket);
};